/**
 * AI 工具任务历史：团队可见性对齐图片空间（self / team_all）。
 */
export const TASK_PERMISSION_TEAM_ALL = 'team_all';
export const TASK_PERMISSION_SELF = 'self';

export function canViewAllTeamTasks(permissionScope) {
  return String(permissionScope || '').trim() === TASK_PERMISSION_TEAM_ALL;
}

/** 仅团队工作区 + team_all 显示操作人筛选 */
export function shouldShowTaskOperatorFilter(workspaceMode, permissionScope) {
  return String(workspaceMode || '').trim() === 'team'
    && canViewAllTeamTasks(permissionScope);
}
